import React, { memo, useEffect, useMemo, useRef, useState } from 'react';

import cn from 'classnames';
import { observer } from 'mobx-react';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';

import PriceChart from '@components/Charts/PriceChart';
import { Loading } from '@components/Element';
import { store } from '@store/index';
import helper from '@utils/helper';
import { formatPrettyValue, getRate } from '@utils/index';
import {
  getListDataCurrentData,
  getRateSymbol
} from '@widget/market/TradeList/utils';

import styles from './index.module.css';

const HotCoin = observer(() => {
  const [usdMarketData, setusdMarketData] = useState([]);
  const [statue, setstatue] = useState('loading');
  const ref = useRef(null);
  const router = useRouter();
  const rateType = getRate();
  const { marketCoins, marketSymbols, coinDetail, otherRateDetail } =
    store.marketStore;

  useEffect(() => {
    if (marketSymbols.length && marketCoins.length) {
      const data = marketSymbols
        .filter((item) => item.coinCode.split('_')[1] === 'USDT')
        .slice(0, 4)
        .map((item) => ({
          ...item,
          ...marketCoins.find(
            (i) => i.coinCode === item.coinCode.split('_')[0].toUpperCase()
          ),
          ...{}
        }));
      setusdMarketData(data);
      setstatue('success');
    }
  }, [marketCoins, marketSymbols]);

  const forMat = (i) => {
    return Number(i) > 0 ? `+${Number(i)}` : Number(i);
  };

  const loadingNode = useMemo(() => {
    return (
      statue === 'loading' && (
        <Loading
          className={styles.loading}
          path="/animations/pulltorefresh.json"
        />
      )
    );
  }, [statue]);

  const rateTypeSymbol = getRateSymbol(rateType);

  return (
    <div className={styles.container}>
      <div className={styles.spin}>
        {loadingNode}
        {statue !== 'loading' && (
          <div className={styles.hotlist}>
            {usdMarketData.map((item) => {
              const precision = item?.symbolPrecision
              const coinArr = [item.coinCode]
              const priceLast = item.priceLast
              const currentData = getListDataCurrentData({
                coinDetail,
                rateType,
                coinArr,
                priceLast,
                precision,
                otherRateDetail
              })

              return (
                <div
                  key={item.ask}
                  className={cn(styles.hotlistItem)}
                  onClick={() => {
                    router.push(`/trade/${item.coinCode}_USDT`)
                  }}
                >
                  <div className={styles.hotlistItemTop}>
                    <div className={styles.hotlistItemTopLeft}>
                      {item.picturePath && (
                        <Image
                          width={32}
                          height={32}
                          alt="KikiTrade"
                          src={item.picturePath}
                        />
                      )}
                    </div>
                    <div className={styles.hotlistItemTopMid}>
                      <div
                        className={cn(
                          styles.hotlistItemTopMidTitle,
                          'DINPro-Medium'
                        )}
                      >
                        {item.name}
                      </div>
                      <div
                        className={cn(styles.hotlistItemTopMidValue, 'DINPro')}
                      >
                        {rateTypeSymbol}
                        {formatPrettyValue(currentData)}
                      </div>
                    </div>
                    <div
                      className={cn(styles.hotlistItemTopRight, 'DINPro-Bold')}
                      style={{
                        color:
                          Number(item.riseAndFall) > 0
                            ? '#1EAE45'
                            : Number(item.riseAndFall) < 0
                              ? '#ED220D'
                              : '#8E939F'
                      }}
                    >
                      {forMat(
                        helper.formatFixNumString(
                          Number(item.riseAndFall ?? '0'),
                          2
                        )
                      )}
                      %
                    </div>
                  </div>
                  <div className={styles.hotlistItemButtom} id="svg" ref={ref}>
                    <PriceChart
                      data={item.priceList?.slice().reverse()}
                      riseAndFall={item.riseAndFall}
                      height={42}
                    // width={svgWidth}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div >
  );
});

export default memo(HotCoin);
